import styled from "@emotion/styled";
import { lazy, Suspense, useEffect } from "react";
import { Outlet, useMatches } from "react-router";

import { useLoginState } from "@skilitics/designer-auth/state";
import { LogoLoading } from "@skilitics/designer-ui-components";

// Only load the login/sign-up code when needed
const AuthScreen = lazy(async () => await import("./ui/AuthScreen"));
const CreateWorkspaceScreen = lazy(async () => await import("./ui/CreateWorkspaceScreen"));

const LoadingContainer = styled.div`
  height: 100dvh;
  width: 100dvw;
  color: ${({ theme }) => (theme.type === "dark" ? theme.brandColor : theme.generalTextIcon)};
  background: ${({ theme }) => theme.surface};
`;

const loading = (
  <LoadingContainer>
    <LogoLoading />
  </LoadingContainer>
);

export const AuthWrapper = () => {
  const state = useLoginState();
  const matches = useMatches();

  useEffect(() => {
    document.getElementById("initial-loader")?.remove();
  }, []);

  // If the leaf route is marked as public, don't show the auth screen.
  // Be aware this is only technically a convenience for an end-user,
  // it does not implement any security!
  // Maybe only check if any matched route is public instead of just the leaf?
  if ((matches.at(-1)?.handle as { public?: boolean } | undefined)?.public) {
    return <Outlet />;
  }

  switch (state) {
    case "restoring":
      return loading;
    case "none":
    case "login-challenge":
      return (
        <Suspense fallback={loading}>
          <AuthScreen />
        </Suspense>
      );
    case "no-workspaces":
      return (
        <Suspense fallback={loading}>
          <CreateWorkspaceScreen />
        </Suspense>
      );
    case "authenticated":
      return <Outlet />;
  }
};
